import React from "react";
import AppLoading from "../components/AppLoading";
import { PagesCommonProps } from "../helpers/pagesUtil";
import SummaryCardContainer from "../components/SummaryCardsContainer";
import { mergeChartConfigWithApiData } from "../helpers/chartConfigHelper";
import { dashboardGraphsOptions, GOOGLE_CHARTS_TYPES } from "../consts/graphs";
import ChartContainer, { ChartContainerProps } from "../components/Charts/ChartContainer";
import useFetchDashboard6Data from "../hooks/fetchDataComponents/useFetchDashboard6Data";

const { TABLE, COLUMNCHART } = GOOGLE_CHARTS_TYPES;

const Paged6DashboardGraphs: React.FC<PagesCommonProps> = ({ filters, graphs = [] }) => {
  const {
    data,
    onScroll,
    onSortChange,
    isLoadingMap,
    endpointsMap,
    exportActions,
    paginationActions,
  } = useFetchDashboard6Data({ filters, graphs });
  
  if (isLoadingMap?.fetchSummaryCardsData) return <AppLoading />;

  const baseChartsConfig: ChartContainerProps[] = [
    {
      //onScroll,
      boxWidth: "95%",
      chartType: COLUMNCHART,
      paginationActions,
      chartId: "fetchPercentageOfCreditsUsedAvailableByOrganisationData",
      title: '% of Credits Used / Available by Organisation',
      options: {
        ...dashboardGraphsOptions.BarChartChartOptions.GetByColumnLength(
          data?.fetchPercentageOfCreditsUsedAvailableByOrganisationData?.data?.[0],
        ),
        isStacked: true,
      },
    },
    {
      onScroll,
      onSortChange,
      chartType: TABLE,
      boxHeight: "450px",
      options: dashboardGraphsOptions.TableChartOptions,
      title: 'Organisation with Users and Credit details',
      //hideSortingOnColumns: ["activeUsers", "inactiveUsers"],
      chartId: "fetchOrganisationWithUsersAndCreditDetailsData",
    },
    {
      onScroll,
      onSortChange,
      boxWidth: "95%",
      chartType: TABLE,
      title: 'Organisations without Credits',
      chartId: "fetchOrganisationsWithoutCreditsData",
      //title: 'Organisations with / without Credits Available',
      options: dashboardGraphsOptions.TableChartOptions,
      //otherActions: withAndWithoutOrgsAndUsersCreditOtherActions(otherActions, data),
    },
    {
      onScroll,
      onSortChange,
      boxWidth: "95%",
      chartType: TABLE,
      title: 'Credit Report',
      chartId: "fetchCreditReportData",
      options: dashboardGraphsOptions.TableChartOptions,
    },
  ];

  // Merge base configuration with API data and filter/sort
  const ChartsListData: ChartContainerProps[] = mergeChartConfigWithApiData(baseChartsConfig, graphs);

  return (
    <>
      <SummaryCardContainer summaryCardsData={data?.fetchSummaryCardsData?.data as any} />
      <div className="charts-container">
        {ChartsListData.map((props, idx) => {
          const chartId = props.chartId;
          if (!chartId) return null;
          return (
            <ChartContainer 
              {...props} 
              key={idx} 
              index={idx}
              queryParams={filters}
              exportActions={exportActions}
              data={data?.[chartId as keyof typeof data]?.data}
              total={data?.[chartId as keyof typeof data]?.total}
              endpoint={endpointsMap?.[chartId as keyof typeof endpointsMap]}
              isLoading={isLoadingMap?.[chartId as keyof typeof isLoadingMap]}
            />
          );
        })}
      </div>
    </>
  );
};

export default Paged6DashboardGraphs;
